"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyPage = exports.paginate = void 0;
const effect_1 = require("effect");
const paginate = (schema) => effect_1.Schema.Struct({
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    items: effect_1.Schema.Array(schema),
}).pipe(effect_1.Schema.filter(({ itemsCount, items }) => itemsCount >= items.length || {
    path: ['itemsCount'],
    message: 'must be greater than the items number',
}, { jsonSchema: {} }), effect_1.Schema.filter(({ itemsCount, pagesCount }) => itemsCount === 0 ||
    itemsCount >= pagesCount || {
    path: ['itemsCount'],
    message: 'must be greater than the pages count',
}, { jsonSchema: {} }), effect_1.Schema.filter(({ pagesCount, page }) => pagesCount >= page || {
    path: ['pagesCount'],
    message: 'must be greater than the current page',
}, { jsonSchema: {} }));
exports.paginate = paginate;
exports.emptyPage = {
    itemsCount: 0,
    pagesCount: 1,
    page: 1,
    items: [],
};
//# sourceMappingURL=pagination.js.map